import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DiagnosticsModule } from '@app/diagnostics/diagnostics.module';
import { PurchaseListsEffects } from '@app/purchase-lists/store/purchase-lists.effects';
import { PurchaseListsFeature } from '@app/purchase-lists/store/purchase-lists.slice';
import { SearchModule } from '@app/search/search.module';
import { ContextSwitcherComponent } from '@layout/components/header/context-switcher/context-switcher.component';
import { ContextComponent } from '@layout/components/header/context/context.component';
import { UserMenuComponent } from '@layout/components/header/user-menu/user-menu.component';
import { MerchantEffects } from '@merchant/store/merchant.effects';
import { MerchantFeature } from '@merchant/store/merchant.slice';
import { SharedModule } from '@shared/shared.module';

import { NewsletterDialogComponent } from './components/footer/components/newsletter-dialog/newsletter-dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderMenuComponent } from './components/header/header-menu/header-menu.component';
import { HeaderComponent } from './components/header/header.component';
import { LoggedOutMenuComponent } from './components/header/logged-out-menu/logged-out-menu.component';
import { SidenavBlogBlockComponent } from './components/sidenav/components/sidenav-blog-block/sidenav-blog-block.component';
import { SidenavJoinBlockComponent } from './components/sidenav/components/sidenav-join-block/sidenav-join-block.component';
import { SidenavMenuTitleComponent } from './components/sidenav/components/sidenav-menu-title/sidenav-menu-title.component';
import { SidenavMenuComponent } from './components/sidenav/components/sidenav-menu/sidenav-menu.component';
import { SidenavSocialPlatformsBlockComponent } from './components/sidenav/components/sidenav-social-platforms-block/sidenav-social-platforms-block.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SidenavEffects } from './components/sidenav/store/sidenav.effects';
import { SidenavFeature } from './components/sidenav/store/sidenav.slice';
import { LayoutContainerComponent } from './containers/layout-container/layout-container.component';

@NgModule({
  declarations: [
    LayoutContainerComponent,
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    SidenavJoinBlockComponent,
    SidenavBlogBlockComponent,
    SidenavSocialPlatformsBlockComponent,
    SidenavMenuTitleComponent,
    NewsletterDialogComponent,
    UserMenuComponent,
    LoggedOutMenuComponent,
    SidenavMenuComponent,
    HeaderMenuComponent,
    ContextSwitcherComponent,
    ContextComponent,
  ],
  imports: [
    CommonModule,
    SearchModule,
    SharedModule,
    StoreModule.forFeature(MerchantFeature),
    StoreModule.forFeature(SidenavFeature),
    StoreModule.forFeature(PurchaseListsFeature),
    EffectsModule.forFeature([
      MerchantEffects,
      SidenavEffects,
      PurchaseListsEffects,
    ]),
    MatDividerModule,
    MatSidenavModule,
    MatDialogModule,
    DiagnosticsModule,
  ],
  exports: [
    LayoutContainerComponent,
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
  ],
})
export class LayoutModule {
  static forRoot(): ModuleWithProviders<LayoutModule> {
    return {
      ngModule: LayoutModule,
    };
  }
}
